// https://github.com/mui-org/material-ui/tree/next/packages/material-ui/src/ButtonGroup
export const MuiButtonBase = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
};
